import {AxiosRequest, HttpUtils} from '../../../utils/HttpUtils';
import {DataGroupDto} from "../dto/DataGroupDto";

export const DataGroupApi = {

    getDataGroupList: async () => {
        try {
            const params = new Map<string, string>();
            const requestUrl = HttpUtils.addQueryString('/v1/account/dataGroup/list', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    constructDataGroupTree: (dataGroupList: Array<DataGroupDto>) => {
        // 构建树
        const dataGroupMap = new Map<string, DataGroupDto>();
        const rootDataGroupList = new Array<DataGroupDto>();
        for (let dataGroup of dataGroupList) {
            dataGroupMap.set(dataGroup.id, dataGroup);
        }

        for (let dataGroup of dataGroupList) {
            if (dataGroup.parentId && dataGroupMap.has(dataGroup.parentId)) {
                const parentDataGroup = dataGroupMap.get(dataGroup.parentId);
                if (parentDataGroup) {
                    // 加了parent的引用，提交的数据转json会异常
                    // dataGroup.parent = parentDataGroup;
                    if (!parentDataGroup.children) {
                        parentDataGroup.children = [];
                    }
                    parentDataGroup.children.push(dataGroup);
                }
            } else {
                rootDataGroupList.push(dataGroup);
            }
        }
        return rootDataGroupList;
    },

    getDataGroupDetail: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/account/dataGroup/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createDataGroup: async (body: DataGroupDto) => {
        try {
            const requestUrl = '/v1/account/dataGroup/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateDataGroup: async (body: DataGroupDto) => {
        try {
            const requestUrl = '/v1/account/dataGroup/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteDataGroup: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/account/dataGroup/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
